// export const base_url = !JSON.parse(localStorage.getItem("importedOldData"))?"http://localhost:6002/v1":"https://hogist.com/crm-api/v1"
// https://hogist.com/crm-api-v2/v1
// export const base_url = "https://hogist.com/crm-api/v1"
//http://192.168.68.102:6001/v1/department
const isOldDataImported = JSON.parse(localStorage.getItem("importedOldData") || "false");

// const urls = {
//   local: "http://localhost:6002/v1",
//   oldProd: "https://hogist.com/crm-api/v1",
//   newProd: "https://tickets.hogist.com/api/v1",
// };  

const urls = {
  local: "http://localhost:6002/v1",
  oldProd: "https://hogist.com/crm-api/v1",
  newProd: "https://hogist.com/ticketing-crm-backend/v1/",
}; 
export const base_url = isOldDataImported ? urls.oldProd : urls.newProd ;
